// extracted by mini-css-extract-plugin
export default {"buttons":"index_buttons__Vtqji","hidden":"index_hidden__60PDO","cancelButton":"index_cancelButton__lPhmF","formItem":"index_formItem__94UUJ","detailLabel":"index_detailLabel__-hTrd"};